// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"756":"cb536744","787":"69021d1a","960":"93221072"}[chunkId] + ".chunk.js";
};